var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import qs from 'qs';
export const USER_NOT_VERIFIED = 'user must verify biometrics';
export const USER_NOT_AUTHENTICATED_ERROR = 'user must be authenticated';
export const USER_NOT_MATCHING_ERROR = 'route param userId must match session userId';
export var EmailTheme;
(function (EmailTheme) {
    EmailTheme["LIGHT"] = "light";
    EmailTheme["DARK"] = "dark";
})(EmailTheme || (EmailTheme = {}));
export var PublicKeyStatus;
(function (PublicKeyStatus) {
    PublicKeyStatus["PENDING"] = "PENDING";
    PublicKeyStatus["COMPLETE"] = "COMPLETE";
})(PublicKeyStatus || (PublicKeyStatus = {}));
export var PublicKeyType;
(function (PublicKeyType) {
    PublicKeyType["MOBILE"] = "MOBILE";
    PublicKeyType["WEB"] = "WEB";
})(PublicKeyType || (PublicKeyType = {}));
export var WalletScheme;
(function (WalletScheme) {
    WalletScheme["DKLS"] = "DKLS";
    WalletScheme["CGGMP"] = "CGGMP";
    WalletScheme["ED25519"] = "ED25519";
})(WalletScheme || (WalletScheme = {}));
export var WalletType;
(function (WalletType) {
    WalletType["EVM"] = "EVM";
    WalletType["SOLANA"] = "SOLANA";
    WalletType["COSMOS"] = "COSMOS";
})(WalletType || (WalletType = {}));
export const NON_ED25519 = [WalletScheme.DKLS, WalletScheme.CGGMP];
export var Chain;
(function (Chain) {
    Chain["ETH"] = "ETH";
    Chain["CELO"] = "CELO";
    Chain["MATIC"] = "MATIC";
})(Chain || (Chain = {}));
export var EncryptorType;
(function (EncryptorType) {
    EncryptorType["USER"] = "USER";
    EncryptorType["RECOVERY"] = "RECOVERY";
    EncryptorType["BIOMETRICS"] = "BIOMETRICS";
})(EncryptorType || (EncryptorType = {}));
export const KeyType = {
    USER: 'USER',
    RECOVERY: 'RECOVERY',
};
export var Network;
(function (Network) {
    Network["ETHEREUM"] = "ETHEREUM";
    Network["ARBITRUM"] = "ARBITRUM";
    Network["BASE"] = "BASE";
    Network["OPTIMISM"] = "OPTIMISM";
    Network["POLYGON"] = "POLYGON";
})(Network || (Network = {}));
export var OnRampProvider;
(function (OnRampProvider) {
    OnRampProvider["RAMP"] = "RAMP";
    OnRampProvider["STRIPE"] = "STRIPE";
})(OnRampProvider || (OnRampProvider = {}));
export var OnRampAsset;
(function (OnRampAsset) {
    OnRampAsset["ETHEREUM"] = "ETHEREUM";
    OnRampAsset["USDC"] = "USDC";
    OnRampAsset["POLYGON"] = "POLYGON";
})(OnRampAsset || (OnRampAsset = {}));
export var OnRampPurchaseStatus;
(function (OnRampPurchaseStatus) {
    OnRampPurchaseStatus["INITIATED"] = "INITIATED";
    OnRampPurchaseStatus["FINISHED"] = "FINISHED";
    OnRampPurchaseStatus["CANCELLED"] = "CANCELLED";
})(OnRampPurchaseStatus || (OnRampPurchaseStatus = {}));
const SESSION_COOKIE_HEADER_NAME = 'x-capsule-sid';
const VERSION_HEADER_NAME = 'x-capsule-version';
class Client {
    constructor({ userManagementHost, apiKey, version, opts, retrieveSessionCookie, persistSessionCookie }) {
        this.createUser = (body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users`, body);
            return res.data;
        });
        this.checkUserExists = (email, phone, countryCode) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/exists?email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}&countryCode=${encodeURIComponent(countryCode)}`);
            return res;
        });
        this.externalWalletLogin = (body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/external-wallets/login`, body);
            return res.data;
        });
        // POST /users/:userId/verify-email
        this.verifyEmail = (userId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/verify-email`, body);
            return res;
        });
        this.verifyPhone = (userId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/verify-identifier`, body);
            return res;
        });
        // POST /users/:userId/biometrics/key
        this.addSessionPublicKey = (userId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/biometrics/key`, body);
            return res;
        });
        // GET /users/:userId/biometrics/keys
        this.getSessionPublicKeys = (userId) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/biometrics/keys`);
            return res;
        });
        // GET /users/:userId/biometrics/:biometricId
        this.getSessionPublicKey = (userId, biometricId) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/biometrics/${biometricId}`);
            return res;
        });
        // PATCH /users/:userId/biometrics/:biometricId
        this.patchSessionPublicKey = (partnerId, userId, biometricId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.patch(`/users/${userId}/biometrics/${biometricId}`, body, {
                headers: {
                    'X-Partner-ID': partnerId,
                },
            });
            return res;
        });
        // GET /biometrics/challenge?email&publicKey
        this.getWebChallenge = (email, phone, countryCode, farcasterUsername, publicKey) => __awaiter(this, void 0, void 0, function* () {
            const queryParams = {};
            if (email) {
                queryParams['email'] = email;
            }
            if (phone) {
                queryParams['phone'] = phone;
            }
            if (countryCode) {
                queryParams['countryCode'] = countryCode;
            }
            if (farcasterUsername) {
                queryParams['farcasterUsername'] = farcasterUsername;
            }
            if (publicKey) {
                queryParams['publicKey'] = publicKey;
            }
            const query = qs.stringify(queryParams);
            const res = yield this.baseRequest.get(`/biometrics/challenge${query === '' ? '' : `?${query}`}`);
            return res.data;
        });
        // POST /touch
        this.touchSession = (regenerate) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/touch?regenerate=${!!regenerate}`);
            return res;
        });
        // POST /biometrics/verify
        this.verifyWebChallenge = (partnerId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/biometrics/verify`, body, {
                headers: {
                    'X-Partner-ID': partnerId,
                },
            });
            return res;
        });
        // GET /users/:userId/biometrics/challenge
        this.getSessionChallenge = (userId) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/biometrics/challenge`);
            return res;
        });
        // POST /users/:userId/biometrics/verify
        this.verifySessionChallenge = (userId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/biometrics/verify`, body);
            return res;
        });
        // POST /users/:userId/wallets
        this.createWallet = (userId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/wallets`, body);
            return res.data;
        });
        // POST /wallets/pregen
        this.createWalletPreGen = (body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/wallets/pregen`, body);
            return res.data;
        });
        // GET /wallets/pregen?pregenIdentifier={pregenIdentifier}&pregenIdentifierType={pregenIdentifierType}
        this.getPregenWallets = (pregenIdentifier_1, pregenIdentifierType_1, ...args_1) => __awaiter(this, [pregenIdentifier_1, pregenIdentifierType_1, ...args_1], void 0, function* (pregenIdentifier, pregenIdentifierType, expand = false) {
            const res = yield this.baseRequest.get(`/wallets/pregen?pregenIdentifier=${encodeURIComponent(pregenIdentifier)}&pregenIdentifierType=${encodeURIComponent(pregenIdentifierType)}${expand ? '&expand=true' : ''}`);
            return res.data;
        });
        // POST /wallets/pregen/claim
        this.claimPregenWallet = (body) => __awaiter(this, void 0, void 0, function* () {
            yield this.baseRequest.post(`/wallets/pregen/claim`, body);
        });
        // POST /users/:userId/wallets/:walletId/transactions/send
        this.sendTransaction = (userId, walletId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/${walletId}/transactions/send`, body);
            return res;
        });
        // functionality changed to only sign transactions and not send them
        // POST /users/:userId/wallets/:walletId/transactions/sign
        this.signTransaction = (userId, walletId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/${walletId}/transactions/sign`, body);
            return res;
        });
        // POST /users/:userId/wallets/:walletId/refresh
        this.refreshKeys = (userId, walletId, oldPartnerId, newPartnerId) => __awaiter(this, void 0, void 0, function* () {
            const body = { oldPartnerId, newPartnerId };
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/${walletId}/refresh`, body);
            return res;
        });
        // PATCH /wallets/pregen/:walletId
        this.updatePregenWallet = (walletId, body) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.patch(`wallets/pregen/${walletId}`, body);
            return res.data;
        });
        // GET /users/:userId/wallets
        this.getWallets = (userId, includePartnerData) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/wallets${includePartnerData ? `?includePartnerData=${encodeURIComponent(includePartnerData)}` : ''}`);
            return res;
        });
        // GET /users/:userId/all-wallets
        this.getAllWallets = (userId) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/all-wallets`);
            return res;
        });
        // POST /users/:userId/wallets/set
        this.setCurrentWalletIds = (userId_1, walletIds_1, ...args_1) => __awaiter(this, [userId_1, walletIds_1, ...args_1], void 0, function* (userId, walletIds, needsWallet = false, sessionLookupId) {
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/set`, {
                walletIds,
                needsWallet,
                sessionLookupId,
            });
            return res;
        });
        // POST /login
        this.login = (props) => __awaiter(this, void 0, void 0, function* () {
            const body = props;
            const res = yield this.baseRequest.post('/login', body);
            return res;
        });
        // POST /login
        this.verifyLogin = (verificationCode) => __awaiter(this, void 0, void 0, function* () {
            const body = { verificationCode };
            const res = yield this.baseRequest.post('/login/verify-email', body);
            return res;
        });
        // GET /logout
        this.logout = () => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get('/logout');
            return res;
        });
        // POST /recovery/verification
        this.recoveryVerification = (email, verificationCode) => __awaiter(this, void 0, void 0, function* () {
            const body = { email, verificationCode };
            const res = yield this.baseRequest.post('/recovery/verification', body);
            return res;
        });
        // POST /recovery
        this.recoveryInit = (email) => __awaiter(this, void 0, void 0, function* () {
            const body = { email };
            const res = yield this.baseRequest.post('/recovery', body);
            return res;
        });
        this.preSignMessage = (userId, walletId, message, scheme) => __awaiter(this, void 0, void 0, function* () {
            const body = { message, scheme };
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/${walletId}/messages/sign`, body);
            return res.data;
        });
        //DELETE /users/:userId
        this.deleteSelf = (userId) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.delete(`/users/${userId}`);
            return res;
        });
        // GET /users/:userId/wallets/:walletId/capsule-share
        this.getCapsuleShare = (userId, walletId) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/wallets/${walletId}/capsule-share`);
            return res.data.share;
        });
        // GET /download-backup-kit/:userId
        this.getBackupKit = (userId) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/download-backup-kit/${userId}`, { responseType: 'blob' });
            return res;
        });
        // TODO remove after this is not optional anymore
        const headers = apiKey ? { 'X-External-API-Key': apiKey } : undefined;
        const axiosConfig = {
            baseURL: userManagementHost,
            withCredentials: true,
            headers,
        };
        if (retrieveSessionCookie) {
            const defaultTransformRequest = Array.isArray(axios.defaults.transformRequest)
                ? axios.defaults.transformRequest
                : [axios.defaults.transformRequest];
            axiosConfig.transformRequest = [
                function (data, headers) {
                    const currentSessionCookie = retrieveSessionCookie();
                    if (currentSessionCookie) {
                        headers[SESSION_COOKIE_HEADER_NAME] = currentSessionCookie;
                    }
                    if (version) {
                        headers[VERSION_HEADER_NAME] = version;
                    }
                    return data;
                },
                ...defaultTransformRequest,
            ];
        }
        if (persistSessionCookie) {
            const defaultTransformResponse = Array.isArray(axios.defaults.transformResponse)
                ? axios.defaults.transformResponse
                : [axios.defaults.transformResponse];
            axiosConfig.transformResponse = [
                ...defaultTransformResponse,
                function (data, headers, _status) {
                    if (headers === null || headers === void 0 ? void 0 : headers[SESSION_COOKIE_HEADER_NAME]) {
                        persistSessionCookie(headers[SESSION_COOKIE_HEADER_NAME]);
                    }
                    return data;
                },
            ];
        }
        this.baseRequest = axios.create(axiosConfig);
        if (opts === null || opts === void 0 ? void 0 : opts.useFetchAdapter) {
            axios.defaults.adapter = function (config) {
                return fetch(config.baseURL + config.url.substring(1), {
                    method: config.method,
                    headers: config.headers,
                    body: config.data,
                    credentials: config.withCredentials ? 'include' : undefined,
                })
                    .then(response => response.text().then(text => ({
                    data: text,
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers,
                    config: config,
                    request: fetch,
                })))
                    .catch(function (reason) {
                    throw reason;
                });
            };
        }
    }
    // DEPRECATED: use uploadUserKeyShares instead
    // POST /users/:userId/wallets/:walletId/key-shares
    uploadKeyshares(userId, walletId, encryptedKeyshares) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { keyShares: encryptedKeyshares };
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/${walletId}/key-shares`, body);
            return res;
        });
    }
    // POST /users/:userId/key-shares
    uploadUserKeyShares(userId, encryptedKeyshares) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { keyShares: encryptedKeyshares };
            const res = yield this.baseRequest.post(`/users/${userId}/key-shares`, body);
            return res;
        });
    }
    // GET /users/:userId/wallets/:walletId/key-shares
    getKeyshare(userId, walletId, type, encryptor) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/wallets/${walletId}/key-shares?type=${type}${encryptor ? `&encryptor=${encryptor}` : ''}`);
            return res;
        });
    }
    // GET /users/:userId/biometrics/key-shares
    getBiometricKeyshares(userId, biometricPublicKey, getAll) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/biometrics/key-shares?publicKey=${biometricPublicKey}&all=${!!getAll}`);
            return res;
        });
    }
    // POST '/users/:userId/temporary-shares',
    uploadTransmissionKeyshares(userId, shares) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { shares };
            const res = yield this.baseRequest.post(`/users/${userId}/temporary-shares`, body);
            return res;
        });
    }
    // GET /users/:userId/temporary-shares returns { temporaryShares: { userId: string, walletId: string, encryptedShare: string, encryptedKey?: string }[] }
    getTransmissionKeyshares(userId, sessionLookupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/temporary-shares?sessionLookupId=${sessionLookupId}`);
            return res;
        });
    }
    // POST '/users/:userId/resend-verification-code
    resendVerificationCode(_a) {
        return __awaiter(this, void 0, void 0, function* () {
            var { userId } = _a, rest = __rest(_a, ["userId"]);
            const res = yield this.baseRequest.post(`/users/${userId}/resend-verification-code`, rest);
            return res;
        });
    }
    // POST '/users/:userId/resend-verification-code-by-phone
    resendVerificationCodeByPhone(_a) {
        return __awaiter(this, void 0, void 0, function* () {
            var { userId } = _a, rest = __rest(_a, ["userId"]);
            const res = yield this.baseRequest.post(`/users/${userId}/resend-verification-code-by-phone`, rest);
            return res;
        });
    }
    // POST recovery/cancel
    cancelRecoveryAttempt(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`recovery/cancel`, { email });
            return res;
        });
    }
    // GET '/2fa/users/:userId/check-status'
    check2FAStatus(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/2fa/users/${userId}/check-status`);
            return res;
        });
    }
    // POST '/2fa/users/:userId/enable'
    enable2FA(userId, verificationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/2fa/users/${userId}/enable`, { verificationCode });
            return res;
        });
    }
    // POST '/2fa/users/:userId/setup'
    setup2FA(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/2fa/users/${userId}/setup`);
            return res;
        });
    }
    // POST /recovery/init
    initializeRecovery(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/recovery/init`, { email });
            return res;
        });
    }
    // POST /auth/farcaster/init
    initializeFarcasterLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/auth/farcaster/init`);
            return res;
        });
    }
    // POST /auth/farcaster/status
    getFarcasterAuthStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/auth/farcaster/status`);
            return res;
        });
    }
    // POST /recovery/init
    initializeRecoveryForPhone(phone, countryCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/recovery/init`, { phone, countryCode });
            return res;
        });
    }
    // POST /recovery/users/:userId/wallets/:walletId/finish
    finalizeRecovery(userId, walletId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/recovery/users/${userId}/wallets/${walletId}/finish`);
            return res;
        });
    }
    // GET /recovery/users/:userId/wallets/:walletId/key-shares
    recoverUserShares(userId, walletId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/recovery/users/${userId}/wallets/${walletId}/key-shares?type=USER&encryptor=RECOVERY`);
            return res;
        });
    }
    // POST /recovery/verify-email
    verifyEmailForRecovery(email, verificationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { email, verificationCode };
            const res = yield this.baseRequest.post(`/recovery/verify-email`, body);
            return res;
        });
    }
    // POST /recovery/verify-identifier
    verifyPhoneForRecovery(phone, countryCode, verificationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { phone, countryCode, verificationCode };
            const res = yield this.baseRequest.post(`/recovery/verify-identifier`, body);
            return res;
        });
    }
    // POST /2fa/verify
    verify2FA(email, verificationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { email, verificationCode };
            const res = yield this.baseRequest.post('/2fa/verify', body);
            return res;
        });
    }
    // POST /2fa/phone/verify
    verify2FAForPhone(phone, countryCode, verificationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { phone, countryCode, verificationCode };
            const res = yield this.baseRequest.post('/2fa/verify', body);
            return res;
        });
    }
    tempTrasmissionInit(message, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { message, userId };
            const res = yield this.baseRequest.post('/temporary-transmissions', body);
            return res;
        });
    }
    tempTrasmission(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/temporary-transmissions/${id}`);
            return res;
        });
    }
    getPartner(partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/partners/${partnerId}`);
            return res;
        });
    }
    acceptScopes(userId, walletId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/${walletId}/scopes/accept`, body);
            return res;
        });
    }
    getPendingTransaction(userId, pendingTransactionid) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/pending-transactions/${pendingTransactionid}`);
            return res;
        });
    }
    acceptPendingTransaction(userId, pendingTransactionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/pending-transactions/${pendingTransactionId}/accept`);
            return res;
        });
    }
    createOnRampPurchase(_a) {
        return __awaiter(this, arguments, void 0, function* ({ userId, walletId, externalWalletAddress, provider, network, asset, testMode = false, }) {
            const walletString = walletId ? `wallets/${walletId}` : `external-wallets/${externalWalletAddress}`;
            const res = yield this.baseRequest.post(`/users/${userId}/${walletString}/purchases`, {
                provider,
                network,
                asset,
                testMode,
            });
            return res;
        });
    }
    updateOnRampPurchase(_a) {
        return __awaiter(this, arguments, void 0, function* ({ userId, walletId, externalWalletAddress, purchaseId, updates, }) {
            const walletString = walletId ? `wallets/${walletId}` : `external-wallets/${externalWalletAddress}`;
            const res = yield this.baseRequest.patch(`/users/${userId}/${walletString}/purchases/${purchaseId}`, updates);
            return res;
        });
    }
    getOnRampPurchase(_a) {
        return __awaiter(this, arguments, void 0, function* ({ userId, walletId, externalWalletAddress, purchaseId, }) {
            const walletString = walletId ? `wallets/${walletId}` : `external-wallets/${externalWalletAddress}`;
            const res = yield this.baseRequest.get(`/users/${userId}/${walletString}/purchases/${purchaseId}`);
            return res;
        });
    }
    distributeCapsuleShare(_a) {
        return __awaiter(this, void 0, void 0, function* () {
            var { userId, walletId } = _a, rest = __rest(_a, ["userId", "walletId"]);
            const body = rest;
            const res = yield this.baseRequest.post(`/users/${userId}/wallets/${walletId}/capsule-share/distribute`, body);
            return res;
        });
    }
    keepSessionAlive(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/session/keep-alive`);
            return res.data;
        });
    }
    persistRecoveryPublicKeys(userId, publicKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.post(`/users/${userId}/recovery-public-keys`, { publicKeys });
            return res.data;
        });
    }
    getRecoveryPublicKeys(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/recovery-public-keys`);
            return res.data;
        });
    }
    uploadEncryptedWalletPrivateKey(userId, encryptedWalletPrivateKey, encryptionKeyHash, biometricPublicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { encryptedWalletPrivateKey, encryptionKeyHash, biometricPublicKey };
            const res = yield this.baseRequest.post(`/users/${userId}/encrypted-wallet-private-keys`, body);
            return res.data;
        });
    }
    getEncryptedWalletPrivateKeys(userId, encryptionKeyHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get(`/users/${userId}/encrypted-wallet-private-keys/${encryptionKeyHash}`);
            return res.data;
        });
    }
    getEthToUsdConversionRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.baseRequest.get('/ethToUsdConversionRate');
            return res.data;
        });
    }
    // GET /users/:userId/wallets/:walletId/refresh-done
    isRefreshDone(userId, walletId, partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const partnerIdStr = partnerId ? `?partnerId=${partnerId}` : '';
            const res = yield this.baseRequest.get(`/users/${userId}/wallets/${walletId}/refresh-done${partnerIdStr}`);
            return res.data;
        });
    }
}
export default Client;
// GET /users/:userId/wallets/:walletId/send (NOTE: endpoint not found in server)
// NOT USED IN DEMO
// POST /users/:userId/wallets/:walletId/presign
// POST /users/:userId/wallets/:walletId/presign-online
// POST /auth/signup/web
// GET /logout
// POST /users/:userId/wallets/:walletId/key
// GET /users/:userId/wallets/:walletId/key
// GET /users/:userId/configurations
// GET /
